import React, { useEffect, useState } from "react";
import energy from "../../assets/energy.png";
import { useTranslation } from "react-i18next";

const WhySamoolah = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [phone, setPhone] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setPhone(window.innerWidth <= 1280 ? true : false);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="relative my-20 max-lg:my-10 px-20 max-lg:px-5">
      <h3 className="text-[#14294F] text-2xl font-semibold">
        {t("Why Choose Samoolah?")}
      </h3>
      <p className="text-[#737E91] text-lg mt-3 w-1/2 max-lg:w-full">
        {t(
          "Samoolah stands out as a trusted platform for contracting and maintenance, offering top tier solutions for your problems at ease."
        )}
      </p>
      <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-10 mt-8">
        <div className="mx-auto flex flex-col items-center">
          <div className="bg-[#FCFBFA] border-2 border-[#EAA182] rounded-full p-3 flex justify-center items-center mx-auto text-center w-fit">
            <img src={energy} className="w-[50px] mx-auto" />
          </div>
          <div className="w-[3px] h-10 bg-[#EAA182] border-dashed"></div>
          <div className="bg-[#FCFBFA] text-[#737E91] text-xl text-center border-4 border-dashed border-[#EAA182] p-10 rounded-3xl">
            {t("Comprehensive Service Platform – Easily book, track, and manage a wide range of home and business services in one place.")}
          </div>
        </div>

        {phone === true ? (
          <>
            <div className="mx-auto flex flex-col items-center">
              <div className="bg-[#FCFBFA] border-2 border-[#EAA182] rounded-full p-3 flex justify-center items-center mx-auto text-center w-fit">
                <img src={energy} className="w-[50px] mx-auto" />
              </div>
              <div className="w-[3px] h-10 bg-[#EAA182] border-dashed"></div>
              <div className="bg-[#FCFBFA] text-[#737E91] text-xl text-center border-4 border-dashed border-[#EAA182] p-10 rounded-3xl">
                {t("Secure & Transparent Payments – Enjoy hassle-free transactions with clear pricing and secure payment options.")}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="mx-auto flex flex-col items-center">
              <div className="bg-[#FCFBFA] text-[#737E91] text-xl text-center border-4 border-dashed border-[#EAA182] p-10 rounded-3xl">
                {t("Secure & Transparent Payments – Enjoy hassle-free transactions with clear pricing and secure payment options.")}
              </div>
              <div className="w-[3px] h-10 bg-[#EAA182] border-dashed"></div>
              <div className="bg-[#FCFBFA] border-2 border-[#EAA182] rounded-full p-3 flex justify-center items-center mx-auto text-center w-fit">
                <img src={energy} className="w-[50px] mx-auto" />
              </div>
            </div>
          </>
        )}

        <div className="mx-auto flex flex-col items-center">
          <div className="bg-[#FCFBFA] border-2 border-[#EAA182] rounded-full p-3 flex justify-center items-center mx-auto text-center w-fit">
            <img src={energy} className="w-[50px] mx-auto" />
          </div>
          <div className="w-[3px] h-10 bg-[#EAA182] border-dashed"></div>
          <div className="bg-[#FCFBFA] text-[#737E91] text-xl text-center border-4 border-dashed border-[#EAA182] p-10 rounded-3xl">
            {t("Trusted Professionals – Get services from verified experts to ensure high-quality and reliable solutions.")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhySamoolah;
